// ** React Imports
import { Fragment } from 'react';
import ComponentSpinner from '@components/spinner/Loading-spinner';

// ** Table Columns
import { columns } from './columns';

// ** Graphql
// import {
//   ListRoads,
//   DeleteRoad,
//   UpdateRoad
// } from '../../../../graphql/Mutation';

// ** Third Party Components

import DataTable from 'react-data-table-component';
import { ChevronDown } from 'react-feather';
import ReactPaginate from 'react-paginate';

// ** Reactstrap Imports
import { Card, Row, Col } from 'reactstrap';
import HeaderRoads from './Header';

// ** Styles
import '@styles/react/libs/tables/react-dataTable-component.scss';
// import { useMutation } from '@apollo/client';

const RoadsList = ({ store, data, variables, handleFetching, loading }) => {
  const handlePagination = (page) => {
    handleFetching({
      roadId: variables.roadId,
      userId: variables.userId,
      input: {
        page: page.selected + 1,
        perPage: variables.input.perPage
      }
    });
  };

  const NoDataRecords = () => {
    return (
      <Row>
        <Col md={12} className="text-align-center mt-4 mb-4">
          No hay registros que mostrar
        </Col>
      </Row>
    );
  };

  const CustomPagination = () => {
    return (
      <ReactPaginate
        previousLabel={''}
        nextLabel={''}
        pageCount={data.totalPages}
        activeClassName="active"
        forcePage={data.page !== 0 ? data.page - 1 : 0}
        onPageChange={(page) => handlePagination(page)}
        pageClassName={'page-item'}
        nextLinkClassName={'page-link'}
        nextClassName={'page-item next'}
        previousClassName={'page-item prev'}
        previousLinkClassName={'page-link'}
        pageLinkClassName={'page-link'}
        containerClassName={
          'pagination react-paginate justify-content-end my-2 pe-1'
        }
      />
    );
  };

  return (
    <Fragment>
      <Card className="overflow-hidden">
        <div className="react-dataTable">
          <DataTable
            noHeader
            subHeader
            sortServer
            pagination
            noDataComponent={<NoDataRecords />}
            responsive
            paginationServer
            columns={[...columns]}
            progressPending={loading}
            progressComponent={<ComponentSpinner />}
            sortIcon={<ChevronDown />}
            className="react-dataTable"
            paginationComponent={CustomPagination}
            data={store}
            subHeaderComponent={<HeaderRoads />}
          />
        </div>
      </Card>
    </Fragment>
  );
};

export default RoadsList;
